var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAtari(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.6529C0 19.6529 3.154 19.2979 5.612 17.2689C7.951 15.3389 8.797 13.6769 9.382 11.7929C9.966 9.90795 10.053 5.37395 10.053 4.02895V0.345947H8.598V1.71095C8.574 3.75195 8.398 7.62895 7.463 10.1549C5.203 16.2419 0 16.7749 0 16.7749V19.6529ZM24 19.6529C24 19.6529 20.846 19.2979 18.39 17.2689C16.048 15.3389 15.203 13.6769 14.618 11.7929C14.035 9.90795 13.947 5.37395 13.947 4.02895V0.345947H15.4L15.401 1.71095C15.425 3.75195 15.603 7.62895 16.539 10.1549C18.797 16.2419 23.999 16.7749 23.999 16.7749L24 19.6529ZM10.659 0.347947H13.344V19.6539H10.66L10.659 0.347947Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtari);
export default __webpack_public_path__ + "static/media/atari.ef6976b5948a0b18d56d64c127f48ddf.svg";
export { ForwardRef as ReactComponent };